import { Component, OnInit, ElementRef } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from '../../services/data.service';
import { InSalesService } from '../../services/inventory/in-sales.service';
export interface Confirmsalesorder {
  title: string;
  message: string;
  data: any;
}
@Component({
  selector: 'app-salesorder-search',
  templateUrl: './salesorder-search.component.html',
  styleUrls: ['./salesorder-search.component.css']
})
export class SalesorderSearchComponent extends DialogComponent<Confirmsalesorder, boolean> implements Confirmsalesorder, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  data: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  fullData: any;
  f: any = {
    Id: 0,
    Date: "",
    QuotationNo: 0,
    VoucherName: "",
    CustomerName: "",
    PaymentTerms: "",
    Total: 0.0,
    Status: ""
  };
  constructor(dialogService: DialogService, private ips: InSalesService, private ds: DataService) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    if (this.f.Id == 0) {
      this.f.Id = ""
    }
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.length > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "Id":
          this.f.Id = e.target.value;
          break;
        case "CustomerName":
          this.f.CustomerName = e.target.value;
          break;
        case "Date":
          this.f.Date = e.target.value;
          break;
      }
      this.selectedRow = 0;
      var a: any = {
        BranchId: this.ds.Settings.BranchId,
        RequestedList: {
          Start: 0,
          FiterText: "",
          Limit: this.ds.Settings.MaxLimit,
          ItemTypeId: this.ds.Settings.ItemTypeId,
          CAType: this.ds.Settings.CATypeId
        },
        FilterData: this.f
      }
      this.ips.Get_QuotationSearch(a).subscribe(res => {
        if (res.Success) {
          this.fullData = res.data
        }
      })
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.Id == abc);
    this.confirm(bcd);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/salesorder-search/salesorder-search.component.ts